export const GetAll = async (arg) => {
  const getTokenFromCookie = () => {
    const cookies = document.cookie.split(";"); // Split all cookies
    const tokenCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("authToken=")
    ); // Find the specific cookie

    if (tokenCookie) {
      return tokenCookie.split("=")[1]; // Get the value of the cookie
    }

    return null; // Return null if the token is not found
  };

  // Usage
  const token = getTokenFromCookie();
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/${arg.subLink}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      // credentials: "include", // Send cookies with request
    }
  );

  try {
    const result = await response.json();
    // console.log(result);
    return result;
  } catch (error) {
    return error;
  }
};
